import { render, staticRenderFns } from "./contrast.vue?vue&type=template&id=122a46b6&"
import script from "./contrast.vue?vue&type=script&lang=js&"
export * from "./contrast.vue?vue&type=script&lang=js&"
import style0 from "./contrast.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports